import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { FileText, Shield } from "lucide-react";
import { EditableField } from "./EditableField";

/**
 * Rental Terms & Pricing Section for Rental Agreement
 */
export const RentalTermsSection = ({ rentalTerms, setRentalTerms, isEditing }) => {
  return (
    <Card>
      <CardHeader className="pb-4">
        <CardTitle className="text-sm font-semibold flex items-center gap-2">
          <FileText className="w-4 h-4 text-primary" />
          RENTAL TERMS & PRICING
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <EditableField 
            label="Daily Rate" 
            value={rentalTerms.dailyRate} 
            isEditing={isEditing} 
            type="number"
            onChange={(v) => setRentalTerms({...rentalTerms, dailyRate: parseFloat(v) || 0})} 
            prefix="$" 
          />
          <EditableField 
            label="Deposit" 
            value={rentalTerms.deposit} 
            isEditing={isEditing} 
            type="number"
            onChange={(v) => setRentalTerms({...rentalTerms, deposit: parseFloat(v) || 0})} 
            prefix="$" 
          />
          <EditableField 
            label="Mileage Limit" 
            value={rentalTerms.mileageLimit} 
            isEditing={isEditing}
            onChange={(v) => setRentalTerms({...rentalTerms, mileageLimit: v})} 
          />
        </div>
        
        <Separator className="my-4" />
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <EditableField 
            label="Extra Mileage Rate" 
            value={rentalTerms.extraMileageRate} 
            isEditing={isEditing} 
            type="number"
            onChange={(v) => setRentalTerms({...rentalTerms, extraMileageRate: parseFloat(v) || 0})} 
            prefix="$" 
            suffix="/km" 
          />
          <EditableField 
            label="Insurance Type" 
            value={rentalTerms.insuranceType} 
            isEditing={isEditing}
            onChange={(v) => setRentalTerms({...rentalTerms, insuranceType: v})} 
            icon={<Shield className="w-3.5 h-3.5" />} 
          />
          <EditableField 
            label="Insurance Rate" 
            value={rentalTerms.insuranceRate} 
            isEditing={isEditing} 
            type="number"
            onChange={(v) => setRentalTerms({...rentalTerms, insuranceRate: parseFloat(v) || 0})} 
            prefix="$" 
            suffix="/day" 
          />
          <EditableField 
            label="Add'l Drivers" 
            value={rentalTerms.additionalDrivers} 
            isEditing={isEditing} 
            type="number"
            onChange={(v) => setRentalTerms({...rentalTerms, additionalDrivers: parseInt(v) || 0})} 
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default RentalTermsSection;
